import { IController, IComponentOptions } from "angular";

export class KpiInboxTemplateCtrl implements IController {}

export const KpiInboxTemplateComponent: IComponentOptions = {
  controller: KpiInboxTemplateCtrl,
  templateUrl: require("./kpi-inbox-template.jade"),
  bindings: {
    item: "<",
    targetType: "<",
    assignee: "<",
    actorNames: "<",
    createdAt: "<",
  },
};
